import React, { useEffect, useState } from 'react';
import { Tooltip } from 'components/common';
import { ListenCondition } from 'components/quote_builder/form_fields/index.js'

const BooleanFormField = ({ config, setValue, value, values, disabled, setFetchInProgress, options, readOnlyValues, register, errors, requestPublishItemOnChange, item, navSection, requestGetExtraItems, d, context }) => {
  const [readOnly, setReadOnly] = useState(false);
  const [readOnlyMessage, setReadOnlyMessage] = useState('');

  useEffect(() => {
    if (readOnlyValues != undefined) {
      readOnlyValues.map((readOnlyValue) => {
        if (readOnlyValue.name == config.name && readOnlyValue.value != undefined) {
          setTimeout(() => {
            setValue(config.name, (_prev) => { return readOnlyValue.value });
            setReadOnly(readOnlyValue.make_read_only == undefined ? (_prev) => { return true; } : (_prev) => { return readOnlyValue.make_read_only; });
          }, 250)
        }
      })
    }
  }, [])

  if (config.listen_conditions != undefined) {
    for (let i = 0; i < config.listen_conditions.length; i++) {
      useEffect(() => {
        let listener = ListenCondition.listener({
          config: config,
          condition: config.listen_conditions[i],
          item: item,
          navSection: navSection,
          setValue: setValue,
          setReadOnly: setReadOnly,
          setReadOnlyMessage: setReadOnlyMessage,
          setNotAvailable: () => {},
          setNotAvailableReason: () => {},
          requestPublishItemOnChange: requestPublishItemOnChange,
          options: options,
          d: d
        });

        document.addEventListener(config.listen_conditions[i].listen, listener);

        return () => { document.removeEventListener(config.listen_conditions[i].listen, listener); }
      }, []);
    }
  }

  useEffect(() => {
    if (config.publish_on_change_key != undefined) {
      var event = new CustomEvent(config.publish_on_change_key, { "detail": value });
      document.dispatchEvent(event);
    }

    if ((config.publish_item_on_change && config.publish_item_if_eval == undefined) || (config.publish_item_on_change && eval(config.publish_item_if_eval))) {
      requestPublishItemOnChange({ publish_item_key: config.publish_item_key });
    }
  }, [value])

  const handleChange = () => {
    setValue(config.name, !value);
    setValue('updated_at', Date.now());
  }

  return (
    <tr>
      <td></td>
      <td align="right">
        <label className="checkbox-label general-frm-element" style={{textAlign: 'left'}}>
          <input
            type="checkbox"
            checked={value === true}
            disabled={readOnly || disabled}
            onChange={handleChange}
          />
          {' '}{t(config.label)} {config.tooltip_text != undefined && <Tooltip title={t(config.tooltip_text)} />}
        </label>
        {config.helper_text != undefined && (
          <><br /><small className="form-text text-muted" dangerouslySetInnerHTML={{ __html: t(config.helper_text) }} /></>
        )}
        {config.footer_note != undefined && (<><small> {t(config.footer_note)} <br /> </small></>)}
        {errors[config.name] && <small className="error"> {errors[config.name].message} </small>}
        {readOnlyMessage != '' && <small className="q-read-only-message"> {readOnlyMessage} </small>}
      </td>
    </tr>
  )
}

export default BooleanFormField;
